module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elias Sacks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Elias Sacks is Assistant Professor of Religious Studies and Jewish Studies at the University of Colorado Boulder.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dhpBBF/tc-custom/9780253023872.jpg?1737195127425",
      "alt": "This image is the cover for the book Moses Mendelssohn's Living Script"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Moses Mendelssohn's Living Script\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Moses Mendelssohn (1729–1786) is often described as the founder of modern Jewish thought and as a leading philosopher of the late Enlightenment. One of Mendelssohn's main concerns was how to conceive of the relationship between Judaism, philosophy, and the civic life of a modern state. Elias Sacks explores Mendelssohn's landmark account of Jewish practice—Judaism's \"living script,\" to use his famous phrase—to present a broader reading of Mendelssohn's writings and extend inquiry into conversations about modernity and religion. By studying Mendelssohn's thought in these dimensions, Sacks suggests that he shows a deep concern with history. Sacks affords a view of a foundational moment in Jewish modernity and forwards new ways of thinking about ritual practice, the development of traditions, and the role of religion in society.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0